<template></template>

<script>
/*
    props
    -----

    attributeId - the id of the attribute
    versionId - the version id
    versionKey - key if version select isn't '0'
    propertyKey - the name of the property to be updated

    methods
    -------

    handleNewValue(newValue:String)
    handleNewValueWithSync(newValue:String)

    events
    ------

    in-progress: a call has been made
    success: the call is complete. success
    error: the call is complete. with error
*/

import axios from 'axios';

let base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: 'attributes-config-api-handler',
    props: {
        attributeId: Number,
        versionId: String,
        propertyKey: String,
    },
    data() {
        return {};
    },
    methods: {
        handleNewValue(newValue) {
            this.saveNewValue(newValue, false);
        },
        handleNewValueWithSync(newValue) {
            this.saveNewValue(newValue, true);
        },
        saveNewValue(newValue, withSync) {
            this.$emit('in-progress');
            axios.post(base_url + '/userinterface/attributes/' + this.attributeId + '/version/' + this.versionId + '/property', {
                "sync": withSync,
                "name": this.propertyKey,
                "value": newValue
            })
            .then((response) => {
                this.$emit('success', response);
            })
            .catch((error) => {
                if (error.response) {
                    this.$emit('error', error.response.data);
                } else {
                    this.$emit('error', error);
                }
            });
        }
    }
}
</script>
